import { render, staticRenderFns } from "./entregas.vue?vue&type=template&id=1280eb54"
import script from "./entregas.vue?vue&type=script&lang=js"
export * from "./entregas.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports